import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import { useCelleraTheme } from "theme/useCelleraTheme";

const ErrorWarningIcon = ({ hasError }: { hasError: boolean }) => {
  const { colors } = useCelleraTheme();

  if (!hasError) return null;

  return (
    <InputAdornment position="end">
      <ErrorOutlinedIcon
        sx={{
          color: colors.error[700],
          fontSize: 24,
          mr: 0.5,
        }}
      />
    </InputAdornment>
  );
};

export default ErrorWarningIcon;
